<cv-baremetrics-calendar *ngIf="dateRangePresets !== null"
    class="d-block daterange daterange--double mb-3" 
    [dropdownOnly]="dropdownOnly"
    [(startDate)]="selectedStartDate" 
    [(endDate)]="selectedEndDate"
    [(selectedPreset)]="selectedPreset"
    [presets]="dateRangePresets"
    (dateChanged)="onDateRangeChanged($event)"
    [earliestDate]="earliestDate"
></cv-baremetrics-calendar>
